const formatCurrency = (value, keepDecimals = false) => {

  if (typeof value === 'undefined' || Number.isNaN(value)) {
    return '';
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  let formatted = formatter.format(value);

  if (!keepDecimals) {
    formatted = formatted.replace(/\D00$/, '');
  }

  return formatted;
};

export default formatCurrency;
